import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquarePlaceholderDashed: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSquarePlaceholderDashed"><Path d="M5.5 3.5H3.5V5.5M18.375 3.5H20.5V5.625M3.5 18.5V20.5H5.5M18.5 20.5H20.5V18.5M10.5 3.5H13.5M20.5 10.5V13.5M13.5 20.5H10.5M3.5 13.5V10.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSquarePlaceholderDashed;
